import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { getDisplayUrl, getTenantDisplayName } from '../tenantHelpers';

const DeleteTenantModal = ({ tenant, isOpen, onClose, onConfirm, isSaving, error }) => {
  if (!isOpen || !tenant) return null;

  return (
    <div className="stm-modal-overlay" onClick={onClose}>
      <div className="stm-modal stm-modal--sm" onClick={(event) => event.stopPropagation()}>
        <header className="stm-modal__header">
          <div>
            <h2>Delete tenant</h2>
            <p>{getTenantDisplayName(tenant)}</p>
          </div>
          <button type="button" className="stm-icon-btn" onClick={onClose} disabled={isSaving} aria-label="Close">
            <FaTimes />
          </button>
        </header>
        <div className="stm-modal__body">
          <p className="stm-modal__text">
            Delete {getTenantDisplayName(tenant)}?
          </p>
          <p className="stm-modal__url">{getDisplayUrl(tenant.tenantUrl)}</p>
          <p className="stm-modal__text stm-muted">
            This permanently removes this shared tenant. This action cannot be undone.
          </p>
          {error && <p className="stm-field-error">{error}</p>}
        </div>
        <footer className="stm-modal__footer">
          <button type="button" className="stm-btn stm-btn--secondary" onClick={onClose} disabled={isSaving}>Cancel</button>
          <button type="button" className="stm-btn stm-btn--destructive" disabled={isSaving} onClick={onConfirm}>
            {isSaving ? 'Deleting...' : 'Delete Tenant'}
          </button>
        </footer>
      </div>
    </div>
  );
};

export default DeleteTenantModal;
